interface TeamMember {
  jobTitle?: {
    label?: string
    weight?: number
  }
}

/**
 * Resolve a GraphQL query sort bug which returns Null before results.
 */
export const sortTeamMembersNull = (results: TeamMember[]) => {
  const withWeight = results.filter(item => item.jobTitle?.weight !== undefined)
  const withoutWeight = results.filter(item => item.jobTitle?.weight === undefined)
  return [...withWeight, ...withoutWeight]
}
